import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { faFileInvoiceDollar, faPlus, faRedoAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Col, Table, Button, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import Layout from '../Layout';
import SpinnerBlock from '../../components/Common/Spinner/Spinner';
import ListSearch from './ListSearch';
import PaymentRow from '../../components/Payments/PaymentRow';

import { listParamsAction } from '../../actions/paramsActions';

import apiMethods from '../../constants/apiMethods';
import api from '../../helpers/api';
import es from '../../lang/es';
import routes from '../../constants/routes';
import alertMessages from '../../helpers/alertMessages';

const Main = () => {
    //Traigo el navigator
    let navigate = useNavigate();
    //Constantes
    const pageLimit = parseInt(process.env.REACT_APP_PAGE_SIZE);
    //Inicializo el state local
    const [ loading, setLoading ] = useState(false);
    const [ payments, setPayments ] = useState([]);
    const [ page, setPage ] = useState(0);
    const [ filter, setFilter ] = useState({
        number: '',
        cover: '',
        type: '',
        state: '',
        jurisdiction: ''
    });
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const params = useSelector( state => state.params.params );
    const jurisdictions = useSelector( state => state.params.jurisdictions );
    const paymentStates = useSelector( state => state.params.paymentStates );
    const paymentTypes = useSelector( state => state.params.paymentTypes );
    //Cargo al inicio los parámetros
    useEffect(() => {
        handleInit();
    }, [page]);
    //Manejo el inicio
    const handleInit = () => {
        //Verifico parámetros
        if(!params){
            loadParams();
        }
        //Cargo los pagos
        loadOrders();
    }
    //Manejo la carga de parámetros
    const loadParams = () => {
        //Llamo al dispatch
        dispatch( listParamsAction() );
    }
    //Manejo la carga de pagos
    const loadOrders = async () => {
        setLoading(true);
        //Hago la consultas
        try{
            const params = {
                ...filter,
                page
            }
            const response = await api.get(apiMethods.PAYMENTS, { params });
            //Obtengo los datos
            const res = response.data;
            //Seteo los pagos
            if(page === 0){
                //Si es la primer página, reemplado
                setPayments(res.data);
            }else{
                //Si no, agrego
                setPayments([
                    ...payments,
                    ...res.data
                ]);
            }
            //Oculto la espera
            setLoading(false);
        }catch(error){
            const errorResponse = error.response;
            //Inicializo
            let errorData = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(errorResponse){
                //Seteo
                errorData = errorResponse.data;
            }
            //Oculto la espera
            setLoading(false);
            //Muestro mensaje de error
            alertMessages.error(errorData.message);
        }
    }
    //Función que maneja la búsqueda
    const handleSearch = e => {
        e.preventDefault();
        //Me fijo el valor de la página
        if(page === 0){
            //Recargo
            loadOrders();
        }else{
            //Tengo que setear a cero la página
            setPage(0);
        }
    }
    //Función para cargar más registros
    const handleLoadMore = e  => {
        e.preventDefault();
        //Incremento el valor
        setPage(page + 1);
    }
    //Acciones
    const actions = [
        {
            title: es.ACTIONS.NEW.toUpperCase(),
            type: 'success',
            icon: faPlus,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CREATE)
            }
        },
        {
            title: es.ACTIONS.CHECKOUT,
            type: 'primary',
            icon: faFileInvoiceDollar,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CHECKOUT)
            }
        }
    ]
    //Render
    return (
        <SpinnerBlock active={loading}>
            <Layout
                title={ es.APP_NAME }
                subtitle={ es.HOME }
                items={[
                    {
                        title: es.HOME
                    }
                ]}
                actions={actions}
            >
                <Col xs={12}>
                    <Alert variant="info">
                        Bienvenido, aquí se listarán todas las <strong>boletas de pago</strong> que haya generado a través de la plataforma. Se mostrarán los más nuevos primero, pero podrá filtrar la información por cualquier de los campos que se muestran a continuación. Simplemente complete alguno de ellos y luego presione el botón <FontAwesomeIcon icon={faSearch} /> <strong>(BUSCAR)</strong>
                    </Alert>
                </Col>

                <ListSearch
                    filter={filter}
                    setFilter={setFilter}
                    handleSearch={handleSearch}
                    jurisdictions={jurisdictions}
                    paymentTypes={paymentTypes}
                    paymentStates={paymentStates}
                />

                <Col xs={12}>
                    <Table bordered responsive size="sm" hover className='d-none d-md-table'>
                        <thead className="thead-light">
                            <tr>
                                <th className="align-middle" width="5%">{ es.FIELDS.DATE }</th>
                                <th className="align-middle">{ es.FIELDS.PROCEEDING }</th>
                                <th className="align-middle">{ es.FIELDS.TYPE_VOUCHER }</th>
                                <th className="align-middle">{ es.FIELDS.AMOUNT }</th>
                                <th className="align-middle">{ es.FIELDS.STATE }</th>
                                <th className="align-middle">{ es.FIELDS.ACTION }</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                payments ? (
                                    payments.map(payment => (
                                        <PaymentRow
                                            key={`pr${payment.id}`}
                                            payment={payment}
                                            showState={true}
                                            endFunction={loadOrders}
                                            isMobile={false}
                                        />
                                    ))
                                ) : null
                            }
                        </tbody>
                    </Table>
                    <Card className='d-md-none'>
                        <Card.Body className='p-0'>
                            <ul className="list-group list-group-flush">
                                {
                                    payments ? (
                                        payments.map( payment => (
                                            <PaymentRow
                                                key={`payment-row-${payment.id}`}
                                                payment={payment}
                                                showState={true}
                                                endFunction={loadOrders}
                                                isMobile={true}
                                            />
                                        ))
                                    ) : null
                                }
                            </ul>
                        </Card.Body>
                    </Card>
                </Col>

                {
                    payments.length > 0 &&
                    payments.length >= (page + 1) * pageLimit ? (
                        <Col xs={12} className='mt-2 mt-md-0'>
                            <Button variant="dark" size="sm" onClick={handleLoadMore} disabled={loading}>
                                <FontAwesomeIcon icon={faRedoAlt} /> { es.LOAD_MORE_RECORDS.toUpperCase() }
                            </Button>
                        </Col>
                    ) : null
                }
            </Layout>
        </SpinnerBlock>
    );
};

export default Main;